import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useRef } from "react";
import { useStore } from "zustand";
import { createUnifiedStore, } from "./createUnifiedStore";
const StoreContext = createContext(null);
export function StoreProvider({ children, verifiedPhone, otpChannels, }) {
    const storeRef = useRef(null);
    if (!storeRef.current) {
        storeRef.current = createUnifiedStore({ verifiedPhone, otpChannels });
    }
    return (_jsx(StoreContext.Provider, { value: storeRef.current, children: children }));
}
export function useUnifiedStore(selector) {
    const store = useContext(StoreContext);
    if (!store) {
        throw new Error("useUnifiedStore must be used inside <StoreProvider>");
    }
    return useStore(store, selector);
}
